import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Table, Icon, Row, Col, Popconfirm, Divider, Input, Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { Animated } from "react-animated-css";
import HeaderContent from '../common/headercontent/HeaderContent';
import AddOccupationModal from './modal/AddOccupationModal';
import moment from 'moment';

import './occupation.css';

import {
  occupationList,
  occupationDelete,
  occupationUpdate,
} from '../../modules/occupation';

class Occupation extends Component {
	constructor(props){
		super(props);
		this.state = {
			addModal: false,
			selectedOccupation: null,
      searchText: '',
      searchedColumn: '',
		}
	}

	componentDidMount() {
		this.getOccupation();		
	}

	toggleAddModal = () => {
    const { addModal } = this.state;
    if (addModal) {
      this.setState({selectedOccupation: null});
    }
		this.setState({ addModal: !addModal });
	}

	onSelectOccupation(occupationId = null) {
		window.scrollTo(0, 0);
		this.setState({ selectedOccupation: null });
		setImmediate(()=> {
			this.setState({ selectedOccupation: occupationId });
		});
	}

	getOccupation() {
		this.props.occupationList();		
	}


	onDeleteConfirm(occupationId) {
		const { selectedOccupation } = this.state;

		this.props.occupationDelete(occupationId).then( 
			(res) => {
				if (occupationId === selectedOccupation) {
					this.setState({ selectedOccupation: null });
				}
				this.getOccupation();
			},
			(err) => {
				this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
			}
		);
	}
  
  onEditOccupation = (selected) => {
    this.setState({selectedOccupation: selected});
    this.toggleAddModal();
  }

  getColumnSearchProps = (dataIndex, displayName) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`搜尋${displayName}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          搜尋
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          重設
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

	render() {
      
		const { addModal, selectedOccupation } = this.state;

		const columns = [{
			title: 'SDS Code',
			dataIndex: 'code',
			key: 'code',
      ...this.getColumnSearchProps('code', 'SDS Code'),
    }, {
			title: '名稱',
			dataIndex: 'name_tc',
			key: 'name_tc',
      ...this.getColumnSearchProps('name_tc', '名稱'),
		}, {
			title: '操作',
			key: '操作',
			render: (text, data) => (
			<span>
        <a onClick={() => this.onEditOccupation(data)}>編輯</a>
        <Divider type="vertical" />
				<Popconfirm title="刪除職業?" onConfirm={() => this.onDeleteConfirm(data._id)} okText="是" cancelText="否"><a>刪除</a></Popconfirm>
			</span>
		),
		}
	];

		const headerData = {
			button: {
				title: <span><Icon type="file-add" /> 新增職業</span>,
				function: () => this.toggleAddModal()
			}
		};
		
		const headerSOccupationData = (selectedOccupation) ? {
			close: {
				title: <Icon type="close-square" />,
				function: () => this.onSelectOccupation()
			}
		} : "";

		let data = [];
		let sOccupation = [];
		if (this.props.occupationData) {
			data = this.props.occupationData.results.map(occupation => {
				return {
          ...occupation,
					name_tc: occupation.name.filter(n => n.lang === 'tc')[0].name,
				}
			});

			sOccupation = this.props.occupationData.results.filter(school=>school._id === selectedOccupation);
    }

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
					<Col>	
							<HeaderContent title="職業名單" subtitle="職業名單" data={headerData} />
							<Card title={<p><span>職業名單 </span></p>}>
								<Table columns={columns} dataSource={data} />
							</Card>

							<AddOccupationModal 
								show={addModal} 
                toggleAddModal={this.toggleAddModal.bind(this)} 
                selected={selectedOccupation}
							/>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	occupationData: state.occupation.data,
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		occupationList,
		occupationDelete,
    occupationUpdate,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Occupation);